import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AlarmManagementState } from '@states/alarm-mangment/alarm-management.reducer';

export const selectAlarmsState = createFeatureSelector<AlarmManagementState>('alarmManagementState');

export const selectActiveAlarms = createSelector(
  selectAlarmsState,
  (state: AlarmManagementState) => state.activeAlarms
);

export const selectCanceledAlarms = createSelector(
  selectAlarmsState,
  (state: AlarmManagementState) => state.canceledAlarms
);

export const selectAllAlarms = createSelector(
  selectAlarmsState,
  (state: AlarmManagementState) => state.allAlarms
);

export const selectSelectedAlarm = createSelector(
  selectAlarmsState,
  (state: AlarmManagementState) => state.selectedAlarm
);

export const selectCheckResult = createSelector(
  selectAlarmsState,
  (state: AlarmManagementState) => state.checkResult
);

export const selectCurrentFilter = createSelector(
  selectAlarmsState,
  (state: AlarmManagementState) => state.currentFilter
);

export const selectIsLoading = createSelector(
  selectAlarmsState,
  (state: AlarmManagementState) => state.isLoading
);

export const selectError = createSelector(
  selectAlarmsState,
  (state: AlarmManagementState) => state.error
);

export const selectActiveAlarmsCount = createSelector(
  selectActiveAlarms,
  (alarms) => alarms.length
);

export const selectHasActiveAlarms = createSelector(
  selectActiveAlarms,
  (alarms) => alarms.length > 0
);
